/**
 * User role enum for Flutter app compatibility
 */
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["USER"] = "USER";
    UserRole["MODERATOR"] = "MODERATOR";
    UserRole["TRAINER"] = "TRAINER";
})(UserRole || (UserRole = {}));
export const MEMBER_PLAN_TIERS = ['FREE', 'EFX', 'PREMIUM'];
/** `code` of the 403 a gated endpoint answers with. */
export const ENTITLEMENT_FEATURE_LOCKED = 'entitlement.feature_locked';
export const ENTITLEMENT_DAILY_LIMIT_REACHED = 'entitlement.daily_limit_reached';
/** The one-time tips, plus steps 2.3 and 2.4, which still show after the guide was skipped. */
export const ONBOARDING_TIP_IDS = ['2.3', '2.4', 'T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8'];
